import { api } from '~/services/api';

export const getAddress = id => api.get(`/districts/${id}/addresses`);

export const postAddress = (id, data) =>
  api.post(`/districts/${id}/addresses`, data);
